<template>
  <van-overlay :show="show" @click="bindCancel">
    <div class="wrapper" @click.stop>
      <div class="container" v-if="show">
        <img
          class="image"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/62d426d0b31030b2a6eb203c654d179e.png"
          alt=""
        />
        <div class="btn-box">
          <div class="btn-item" @click="bindConfirm">残忍放弃</div>
          <div class="btn-item btn-confirm" @click="bindCancel">继续答题</div>
        </div>
        <div class="close iconfont icon-cha" @click.stop="bindCancel"></div>
      </div>
    </div>
  </van-overlay>
  <!-- <van-popup v-model="show" round @closed="bindClose">
        <div class="container" v-if="show">
            <img class="image" src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/62d426d0b31030b2a6eb203c654d179e.png"
                alt="">
            <div class="btn-box">
                <div class="btn-item" @click="bindConfirm">残忍放弃</div>
                <div class="btn-item btn-confirm" @click="bindCancel">继续答题</div>
            </div>
            <div class="close iconfont icon-cha"></div>
        </div>
    </van-popup> -->
</template>
<script>
import MyRuler from '@/components/app/ruler/ruler.vue'
export default {
  components: {
    MyRuler
  },
  props: {
    value: {
      //是否显示popup
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false
    }
  },
  watch: {
    value() {
      this.show = this.value
    }
  },
  computed: {},
  created() {
    this.show = this.value
  },
  mounted() {},
  methods: {
    bindClose() {
      this.$emit('input', false)
    },
    bindConfirm() {
      this.$emit('confirm')
      this.bindClose()
    },
    bindCancel() {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
.van-popup {
  background-color: transparent;
}
.container {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  .image {
    width: 335px;
    height: 340px;
  }
  .close {
    width: 24px;
    height: 24px;
    position: absolute;
    left: 50%;
    bottom: -40px;
    transform: translate(-50%);
    border-radius: 50%;
    border: 1px solid #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }
  .btn-box {
    width: 232px;
    box-sizing: border-box;
    position: absolute;
    transform: translate(-50%, 0%);
    left: 50%;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 0px 20px;

    .btn-item {
      width: 109px;
      height: 38px;
      background: #f1f1f1;
      border-radius: 20px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #0d0d0d;
      line-height: 38px;
      text-align: center;
    }

    .btn-confirm {
      background: #0d0d0d;
      color: #ffffff;
    }
  }
}
</style>
